// extracted by mini-css-extract-plugin
export default {"PaymentList":"PaymentList_PaymentList__8QOTb"};